var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mb-5 mr-8",attrs:{"color":"primary","small":"","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._t("default",function(){return [_vm._v("Nee")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }